import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ThemeStore } from '@drf/core';

@Component({
  selector: 'drf-root',
  templateUrl: './app.component.html',
  styleUrl: './app.scss',
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  readonly #themeStore = inject(ThemeStore);

  ngOnInit(): void {
    this.#themeStore.init();
  }
}
